
const CamelItem = ({ id }: { id: Number }) => {
    const getImageUrl = () => {
        const url = `https://bafybeih3j2fjb7zu66x5np4qmtiuprfztsmyjfrurvou7euleaczh63g6q.ipfs.nftstorage.link/images1/${id}.png`
        return url
    }

    return (<>
        <div className=" w-[17.4vw] min-w-[300px] min-h-[300px] h-[17.4vw] mx-4 my-4 px-[0.267vw] py-[0.267vw] border-2 border-white">
            <img src={getImageUrl()} alt={`${id}`}></img>
        </div>
    </>)
}
export default CamelItem